import { createFileRoute } from "@tanstack/react-router";
import { SectionPage } from "@/components/site/SectionPage";

export const Route = createFileRoute("/new-arrivals")({
  head: () => ({
    meta: [
      { title: "New Arrivals — KAKAIYS" },
      { name: "description", content: "The latest pieces from our Sialkot atelier — fresh lambskin jackets, calfskin accessories, and cowhide rider gear." },
      { property: "og:title", content: "New Arrivals — KAKAIYS" },
      { property: "og:description", content: "The latest from our atelier." },
      { name: "twitter:image", content: "https://tvmsfjwzfnidomctinqz.supabase.co/storage/v1/object/public/product-images/hover/midnight-trench.png" },
      { property: "og:url", content: "https://kakaiys.com/new-arrivals" },
    ],
      links: [{ rel: "canonical", href: "https://kakaiys.com/new-arrivals" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "New Arrivals — KAKAIYS",
          description: "The latest hand-finished leather pieces from the KAKAIYS atelier.",
          url: "https://kakaiys.com/new-arrivals",
          isPartOf: { "@id": "https://kakaiys.com/#website" },
          publisher: { "@id": "https://kakaiys.com/#organization" },
        }),
      },
    ],
  }),
  component: () => (
    <SectionPage
      eyebrow="Just In"
      title="New Arrivals."
      subtitle="The pieces that left our atelier this season."
      filterTag="new-arrivals"
    />
  ),
});
